import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { Alert, FormLabel, IconButton, InputAdornment } from '@mui/material'
import { FC, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import Input from '../../../RouteWizard/Input'
import {
  CredentialField,
  getCredentialFields,
} from './supplierCredentialConfig'

interface CredentialFieldsProps {
  formDisabled?: boolean
}

const CredentialFields: FC<CredentialFieldsProps> = ({
  formDisabled = false,
}) => {
  const [showAppSecret, setShowAppSecret] = useState(false)
  const [showAPIKey, setShowAPIKey] = useState(false)
  const { control } = useFormContext()
  const supplierGroupId = useWatch({ control, name: 'supplierGroupId' })

  const credentials = getCredentialFields(Number(supplierGroupId))
  const has = (field: CredentialField) => credentials.includes(field)

  if (credentials.length === 0) {
    return (
      <Alert severity="info">
        Credentials for this dispatch platform are not yet configurable. Please
        contact your administrator to update integration details.
      </Alert>
    )
  }

  return (
    <>
      <FormLabel>Credentials</FormLabel>
      {has('endpoint') && (
        <Input name="endpoint" label="Endpoint" disabled={formDisabled} />
      )}
      {has('apiKey') && (
        <Input
          name="apiKey"
          label="API Key"
          type={showAPIKey ? 'text' : 'password'}
          disabled={formDisabled}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle API key visibility"
                  onClick={() => setShowAPIKey(!showAPIKey)}
                  onMouseDown={() => setShowAPIKey(!showAPIKey)}
                >
                  {showAPIKey ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
      {(has('appKey') || has('appSecret')) && (
        <FormLabel>App Key & Secret</FormLabel>
      )}
      {has('appKey') && (
        <Input name="appKey" label="App Key" disabled={formDisabled} />
      )}
      {has('appSecret') && (
        <Input
          name="appSecret"
          label="App Secret"
          type={showAppSecret ? 'text' : 'password'}
          disabled={formDisabled}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle App Secret visibility"
                  onClick={() => setShowAppSecret(!showAppSecret)}
                  onMouseDown={() => setShowAppSecret(!showAppSecret)}
                >
                  {showAppSecret ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
      {has('dispatchReference') && (
        <Input
          name="dispatchReference"
          label="Dispatch Reference"
          disabled={formDisabled}
        />
      )}
      {(has('accountNumber') || has('unmanagedAccountNumber')) && (
        <FormLabel>Account Information</FormLabel>
      )}
      {has('accountNumber') && (
        <Input
          name="accountNumber"
          label="Account Number"
          disabled={formDisabled}
        />
      )}
      {has('unmanagedAccountNumber') && (
        <Input
          name="unmanagedAccountNumber"
          label="Unmanaged Account Number"
          disabled={formDisabled}
        />
      )}
    </>
  )
}

export default CredentialFields
